module.exports = __webpack_public_path__ + "static/media/theater-masks.99beca29.svg";